import React, { useState, useEffect, useContext } from "react";
import { AppContext } from '../context/index';
import ReactTooltip from 'react-tooltip';
import Cleave from 'cleave.js/react';
import moment from 'moment';
import { asyncHandler, validateAwb, notify } from '../utils';
import ModalWiki from './ModalWiki';
import classnames from 'classnames';
import packageInfo from '../../package.json';
import domtoimage from 'dom-to-image-more';

import {
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Input
} from "reactstrap";

import {
    useWindowSize,
} from '@react-hook/window-size'

import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import ModalReportBug from '../components/ModalReportBug';
import ModalAppsMenu from '../components/appsMenu/ModalAppsMenu';
import ModalBombThreat from './misc/bombTreatReport/ModalBombThreat';
import useBrowser from '../customHooks/useBrowser';

import {
    setContainerClassnames,
    clickOnMobileMenu,
    changeLocale
} from "../redux/actions";

import { MobileMenuIcon, MenuIcon } from "../components/svg";

import useLoading from "../customHooks/useLoading";
import { Button } from "reactstrap";
import styled from "styled-components";
import { useSetRecoilState } from "recoil";
import { passwordManagerState } from "./passwordManager";
import useLogout from "../customHooks/useLogout";
import SupportRequestModal from "../views/portal/ManageTickets/SupportRequestModal";
import { selectedTicketIdState, supportRequestModalState } from "../views/portal/ManageTickets/atoms";
import ScreenshotComponent from "./TakeScreenshot";
import html2canvas from "html2canvas";
import { screenShotState } from "../globals/atoms";
import { useSearchAwb } from "./searchAwb/useSearchAwb";
import useLogNotes from "./logNotes/useLogNotes";
import apiClient from "../apiClient";
import { useAthenaStore } from "./searchAwb/useAthenaStore";

const version = packageInfo.version;

const TopNav = (props) => {

    const { customLogout } = useLogout();

    // const logoutWithRedirect = () =>
    //     logout({
    //         logoutParams: {
    //             returnTo: window.location.origin,
    //         }
    //     });

    const {
        history,
        containerClassnames,
        menuClickCount,
        selectedMenuHasSubItems,
        setContainerClassnamesAction,
        broadcastUpdate,
        handleReportBug
    } = props && props;

    const {
        user,
        wiki,
        setModalLocation,
        setDisplaySubmenu,
        setSignOut
    } = useContext(AppContext);

    const setScreenshot = useSetRecoilState(screenShotState);

    const {
        searchAwbNum,
        setSearchAwbNum,
        handleSearchAwb
    } = useSearchAwb();

    const { handleAddNotes } = useLogNotes();

    const { customWikiTitle, setCustomWikiTitle } = wiki;
    const [isInFullScreen, setIsFullScreen] = useState(false);
    const [modalBugReportingOpen, setModalBugReportingOpen] = useState(false);
    const [modalAppsMenuOpen, setModalAppsMenuOpen] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [width, height] = useWindowSize();
    const [submittingBug, setSubmittingBug] = useState(false);
    const [wikiTitle, setWikiTitle] = useState('');
    const [modalBombThreat, setModalBombThreat] = useState(false);
    const [airlineLogo, setAirlineLogo] = useState('');
    const { setLoading } = useLoading();
    const setSupportRequestModal = useSetRecoilState(supportRequestModalState);
    const setSelectedTicketIdState = useSetRecoilState(selectedTicketIdState);

    useEffect(() => {
        if (user && user.displayName) {
            const { displayName } = user;
            const names = displayName.split(' ');
            if (names.length > 0) {
                setFirstName(names[0]);
            }
        }
    }, [user]);

    const checkIsInFullScreen = () => {
        return (
            (document.fullscreenElement && document.fullscreenElement !== null) ||
            (document.webkitFullscreenElement &&
                document.webkitFullscreenElement !== null) ||
            (document.mozFullScreenElement &&
                document.mozFullScreenElement !== null) ||
            (document.msFullscreenElement && document.msFullscreenElement !== null)
        );
    };

    const toggleFullScreen = () => {
        const isInFullScreen = checkIsInFullScreen();

        var docElm = document.documentElement;
        if (!isInFullScreen) {
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
            } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
            } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
        setIsFullScreen(!isInFullScreen);
    };

    const reportBug = asyncHandler(async (data) => {
        const payment = data.selectedBugType === 'PAYMENT';
        data.subject = `${payment ? 'PAYMENT ' : ''}: ${history.location.pathname.replace('/EOS/', '')} by ${user.s_email}`;
        data.submittedBy = firstName;
        data.unit = user.s_unit;

        setSubmittingBug(true);

        const res = await apiClient.post('/reportBug', { data });

        setSubmittingBug(false);

        if (res.status === 200) {
            setModalBugReportingOpen(false);
            notify('Bug reported, thank you.');
        }
    })

    const menuButtonClick = (e, _clickCount, _conClassnames) => {
        e.preventDefault();

        setTimeout(() => {
            const event = document.createEvent('HTMLEvents');
            event.initEvent('resize', false, false);
            window.dispatchEvent(event);
        }, 350);
        setContainerClassnamesAction(
            _clickCount + 1,
            _conClassnames,
            selectedMenuHasSubItems
        );
        if (_clickCount === 0) {
            setDisplaySubmenu(false);
        } else if (_clickCount === 3) {
            setDisplaySubmenu(true);
        }
    };

    const handleCreateTicket = () => {
        html2canvas(document.body).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const file = {
                base64: imgData, // Extracting base64 string
                type: 'image/png',
                requiredName: 'screenshot'
            };
            setScreenshot(file);
        });
        setSupportRequestModal(true);
        setSelectedTicketIdState(undefined);
    }

    const clickOnMobileMenu = () => {
        const currentClasses = document.getElementById('app-container').classList;
        if (currentClasses.value.includes('main-hidden')) {
            document.getElementById('app-container').classList.remove('main-hidden');
        } else {
            document.getElementById('app-container').classList.add('main-hidden');
        }
    };

    const browser = useBrowser();
    const isChrome = browser === 'Chrome';

    const isMobile = width <= 600;

    const [modalWiki, setModalWiki] = useState(false);

    useEffect(() => {
        setCustomWikiTitle(null);
        if (history.location.pathname) {
            setWikiTitle(history.location.pathname.replace('/EOS/', '').toUpperCase());
        }
    }, [history.location]);

    useEffect(() => {
        if (customWikiTitle && customWikiTitle.length > 0) {
            setWikiTitle(customWikiTitle);
            setModalWiki(true);
        }
    }, [customWikiTitle]);

    useEffect(() => {
        if (!modalWiki) {
            setCustomWikiTitle(null);
        }
    }, [modalWiki]);

    const handleLogout = async () => {
        setSignOut(true);
        await customLogout();
    }

    const invalidSearchMawb = searchAwbNum.length > 0 && !validateAwb(searchAwbNum);

    const setOpenVault = useSetRecoilState(passwordManagerState);

    const managePasswords = () => setOpenVault(true);

    const env
        = window.location.origin.includes('eos1') ?
            {
                title: 'PREVIEW',
                color: '#27BD2D'
            } :
            window.location.origin.includes('system') ?
                {
                    title: 'BACKUP',
                    color: '#BD5527'
                } :
                null;

    const openAthena = useAthenaStore((s) => s.openAthena);

    const searchAthena = () => {
        if (invalidSearchMawb) return;
        openAthena(searchAwbNum);
    }

    return (
        <nav className="navbar fixed-top py-0" style={{ height: '75px', display: 'flex', justifyContent: 'space-between' }} data-testid={'component-top-nav'}>
            <div className="d-flex align-items-center navbar-left">
                <ReactTooltip />
                <NavLink
                    to="#"
                    location={{}}
                    className="menu-button d-none d-md-block"
                    onClick={e =>
                        menuButtonClick(e, menuClickCount, containerClassnames)
                    }
                >
                    <MenuIcon />
                </NavLink>
                {
                    !isMobile &&
                    <div className="header-icons d-inline-block align-middle mr-4" data-tip={user.connectedToBackend ? 'Connected' : 'Connecting'}>
                        <i className={`ml-4 fad fa-database ${user.connectedToBackend ? 'text-success' : 'text-danger'}`} style={{ fontSize: '24px' }}></i>
                    </div>
                }
                {/* <div className="header-icons d-inline-block align-middle hover-title" data-tip='Comms'>
                    <i className={classnames(`fad mx-2`, loggedIn ? 'fa-phone text-success' : 'fa-phone-slash text-danger', { 'pulse': ringIncomingCall })} style={{ fontSize: '24px' }} onClick={() => loggedIn && setModalComms(true)}/>
                </div> */}
                {
                    width > 1080 &&
                    <div className="header-icons d-inline-block align-middle">
                        <i className={'fad fa-question text-success'} style={{ fontSize: '24px' }} onClick={() => setModalWiki(true)} data-tip={'Wiki'} />
                    </div>
                }
                <div className="d-inline-block mx-2" style={{ fontSize: '14px' }}>
                    <div className="header-icons d-inline-block align-middle hover-title" data-tip={'Apps'}>
                        <i className="fad fa-grip-horizontal mx-2 text-success" onClick={() => setModalAppsMenuOpen(true)} style={{ fontSize: '24px' }}></i>
                    </div>
                </div>
                <Button>
                    {version}
                </Button>
                {
                    broadcastUpdate &&
                    <div className="d-inline-block mx-2" style={{ fontSize: '14px' }}>
                        <div className="header-icons d-inline-block align-middle hover-title" data-tip={'Click to Update'}>
                            <UpdateBroadcastBtn
                                className={'pulse'}
                                onClick={() => window.location.href = window.location.href.replace(/#.*$/, '')}
                            >
                                Update Now
                            </UpdateBroadcastBtn>
                        </div>
                    </div>
                }
            </div>
            <a
                className="navbar-logo"
                href="/"
                style={{
                    marginTop: '0px',
                    bottom: '20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center' // <-- This is the key addition
                }}
            >
                <img
                    src='/assets/img/eos-logo-1.png'
                    style={{ height: '50px', width: 'auto', background: 'transparent' }}
                    className={'mr-3'}
                />
                <img
                    src='/assets/img/choice-logo.png'
                    style={{ height: '50px', width: 'auto', background: 'transparent' }}
                    className={'mr-3'}
                />

                {env && <Title style={{ color: env.color }}>{env.title}</Title>}

                <img
                    src={airlineLogo}
                    style={{ height: '50px', width: 'auto' }}
                />
            </a>

            <div className="navbar-right">

                {/* <TopnavDarkSwitch/> */}
                {
                    !isMobile &&
                    <div className='d-inline-block align-middle'>
                        <div className="d-inline-block mr-5">
                            <div className="header-icons d-inline-block align-middle hover-title" data-tip={''}>
                                <form onSubmit={(e) => handleSearchAwb(e)}>
                                    <Cleave
                                        placeholder=''
                                        options={{
                                            delimiter: '-',
                                            blocks: [3, 4, 4],
                                            numericOnly: true
                                        }}
                                        onChange={e => setSearchAwbNum(e.target.rawValue)}
                                        value={searchAwbNum}
                                        className={`search-awb-input`}
                                        style={{ width: '150px', border: invalidSearchMawb ? '2px solid red' : '' }}

                                    />
                                    <i className={`fad fa-search search-awb-icon ${invalidSearchMawb ? 'text-danger' : 'text-success'}`} onClick={() => handleSearchAwb(null)} style={{ fontSize: '24px' }}></i>
                                </form>
                            </div>
                        </div>
                        <div className="d-inline-block">
                            <div className="header-icons d-inline-block align-middle hover-title" data-tip={'Athena'}>
                                {
                                    ['BYRON@CHOICE.AERO', 'MOZART@CHOICE.AERO', 'FRANK@CHOICE.AERO', 'IQRA@CHOICE.AERO', 'JULIO@CHOICE.AERO', 'VVIEIRA@CHOICE.AERO', 'DPIMENTA@CHOICE.AERO', 'KWANG@CHOICE.AERO'].includes(user.s_email.toUpperCase()) && (
                                        <i class="fa-duotone fa-regular fa-microchip-ai text-success mx-2" style={{ fontSize: '24px' }} onClick={searchAthena}></i>
                                    )
                                }
                            </div>
                        </div>
                        <div className="d-inline-block">
                            <div className="header-icons d-inline-block align-middle hover-title" data-tip={'Add Notes'}>
                                <i onClick={() => handleAddNotes(true)} className="fa-solid fa-memo-pad text-success" style={{ fontSize: '24px' }}></i>
                            </div>
                        </div>
                        <div className="d-inline-block" style={{ fontSize: '14px' }}>
                            <div className="header-icons d-inline-block align-middle" data-tip={'Email'}>
                                <a href='https://outlook.office.com/mail/inbox' target='blank'>
                                    <i className="fad fa-envelope text-success" style={{ fontSize: '24px' }}></i>
                                    <span style={{ position: 'absolute', bottom: '21px' }}>{user.unreadEmailCount}</span>
                                </a>
                            </div>
                        </div>
                        <div className="d-inline-block ml-2" style={{ fontSize: '14px' }}>
                            <div className="header-icons d-inline-block align-middle" data-tip={'Passwords'}>
                                <i className="fa-duotone fa-vault text-success" onClick={managePasswords} style={{ fontSize: '24px' }}></i>
                            </div>
                        </div>
                    </div>
                }

                <div className="user mx-2 d-inline-block">
                    <UncontrolledDropdown className="dropdown-menu-right">
                        <DropdownToggle className="p-0" color="empty" data-testid={'top-nav-drop-down'}>
                            <img style={{ borderRadius: '50%', height: '40px', width: 'auto' }} src={user.s_photo_link || 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png'} />
                        </DropdownToggle>
                        <DropdownMenu className="mt-3" right data-testid={'top-nav-drop-down-menu'}>
                            <DropdownItem>
                                {firstName}
                            </DropdownItem>
                            <DropdownItem onClick={() => setModalLocation(true)}>
                                {user.s_unit} {user.b_airline && ` - ${user.s_airline_code}`}
                            </DropdownItem>
                            <NavLink
                                to="/EOS/Portal/SiteMap"
                                location={{}}
                            >
                                <DropdownItem>
                                    Site Map
                                </DropdownItem>
                            </NavLink>
                            <DropdownItem onClick={() => setModalBombThreat(true)} className={'text-danger'} data-testid={'btn-bomb-threat'}>
                                Bomb Threat
                            </DropdownItem>
                            <DropdownItem onClick={() => handleLogout()}>
                                Sign out
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </div>
            <SupportRequestModal />
            <ModalReportBug
                open={modalBugReportingOpen}
                handleModal={setModalBugReportingOpen}
                reportBug={reportBug}
                history={history}
                submittingBug={submittingBug}
                setCustomWikiTitle={setCustomWikiTitle}
            />
            <ModalWiki
                modal={modalWiki}
                setModal={setModalWiki}
                user={user}
                wikiTitle={wikiTitle}
            />
            <ModalAppsMenu
                modal={modalAppsMenuOpen}
                setModal={setModalAppsMenuOpen}
            />
            <ModalBombThreat
                modal={modalBombThreat}
                setModal={setModalBombThreat}
                user={user}
                notify={notify}
            />
        </nav>
    );
}
const mapStateToProps = ({ menu, settings }) => {
    const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
    const { locale } = settings;
    return {
        containerClassnames,
        menuClickCount,
        selectedMenuHasSubItems,
        locale,
    };
};

const UpdateBroadcastBtn = styled.button`
    color: black;
    background-color: gold;
    animation: pulse 1s infinite;
    border-radius: 25px;
    border: none;

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0px rgba(249,213,4, 1);
        }

        100% {
            box-shadow: 0 0 0 30px rgba(249,213,4, 0);
        }
    }
`;

const Title = styled.h2`
    margin: 0px;
    display: none;

    @media (min-width: 1700px) {
        display: block;
    }
`;


export default (
    connect(mapStateToProps, {
        setContainerClassnamesAction: setContainerClassnames,
        clickOnMobileMenuAction: clickOnMobileMenu,
        changeLocaleAction: changeLocale,
    })(TopNav)
);